import {WatchQueryFetchPolicy} from '@apollo/client';
import {useCommunityFeaturesQuery} from '../../generated/graphql';
import {edgesToNodes} from '../../transforms/edgesToNodes';

type CommunityFeature = {
  communityId: string;
  features: string[];
};

type CommunityFeatureResponse = ReturnType<typeof useCommunityFeaturesQuery> & {
  data: CommunityFeature[];
};

export const useCommunitiesFeatures = (
  fetchPolicy: WatchQueryFetchPolicy = 'network-only',
): CommunityFeatureResponse => {
  const communitiesFeaturesResponse = useCommunityFeaturesQuery({
    fetchPolicy,
  });

  return {
    ...communitiesFeaturesResponse,
    data: edgesToNodes(
      communitiesFeaturesResponse.data?.communities?.edges,
    )?.map(community => ({
      communityId: community.id,
      features: edgesToNodes(community.features?.edges).map(
        feature => feature.name,
      ),
    })),
  };
};
